export default __webpack_public_path__ + "static/media/underprocess.cfe20bd0.svg";